import { getRootAppWindow } from "../../utils/getRootAppWindow";
const getLocalDialog = () => {
    const iframeMode = new URLSearchParams(window.location.search).get("iframeMode");
    if (iframeMode == "true") {
        return window.ParentWindow.DialogManager.LocalDialog;
    }
    let dialog = window.LocalUI.Dialog;
    dialog.setupDocument(window.document);
    return dialog;
};
export function DialogManager() {
    const top = getRootAppWindow(window);
    return {
        //Global Dialog covers whole application. The user must process the dialog to proceed further.
        GlobalDialog: top.RootAPI.GlobalDialog,
        //Local dialog is displayed inside current iFrame and covers only current iframe.
        //User is able to work with other parts of application (for example user can switch to another tab and work with them)
        LocalDialog: window.LocalUI ? getLocalDialog() : top.RootAPI.GlobalDialog,
    };
}
